import { RootInitialState } from 'core/common/store/rootReducer';

export const getOrderData = (state: RootInitialState) => state.payments.orderData;

export const getPaymentProcessStep = (state: RootInitialState) => {
  return state.payments.paymentProcessStep;
};

export const getPaymentError = (state: RootInitialState) => {
  return state.payments.paymentError;
};

export const getPaymentFormMerchantData = (state: RootInitialState) => {
  return state.payments.formMerchantData;
};

export const getPaymentFormPaypalData = (state: RootInitialState) => {
  return state.payments.formPaypalData;
};

export const getResignFormData = (state: RootInitialState) => {
  return state.payments.resignFormData;
};

export const getOrderId = (state: RootInitialState) => state.payments.orderId;

export const getRecurringData = (state: RootInitialState) => {
  return state.payments.recurringData;
};

export const getPaymentCardBank = (state: RootInitialState) => {
  return state.payments.paymentCardBank;
};

export const getPaymentCardBrand = (state: RootInitialState) => {
  return state.payments.paymentCardBrand;
};

export const getPaymentCardType = (state: RootInitialState) => {
  return state.payments.paymentCardType;
};

export const getPaymentType = (state: RootInitialState) => {
  return state.payments.paymentType;
};
